export const getHealthInsuranceRwState = state => state?.healthInsuranceRwanda;
